import { About, Knowledge, SoftSkills, Certifications, Experience } from "./";

export const renderSection = {
  knowledge: <Knowledge />,
  softSkills: <SoftSkills />,
  about: <About />,
  certifications: <Certifications />,
  experience: <Experience />,
};
